const RenderGameKey: React.FC<{ cryptoKey: string }> = ({ cryptoKey }) => {
  const letters = cryptoKey.toUpperCase().split("");
  return (
    <>
      {[0, 1, 2].map((rowIndex) => (
        <div key={rowIndex} className="crypto-board-game-key-row" data-testid="crypto-key-row">
          {[0, 1, 2].map((columnIndex) => {
            let index = rowIndex * 3 + columnIndex;
            return (
              <div key={index} className="crypto-board-game-key-letter" data-testid="crypto-key-letter">
                {letters[index]}
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};
export default RenderGameKey;
